import { Routes } from 'react-router-dom';
import pages from './pages';

const DomainRoute = () => {
  return <Routes>{pages}</Routes>;
};

export default DomainRoute;
